var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-field__container",style:(_vm.model.attributes.labelStyle)},[_c('span',{style:(_vm.model.attributes.labelTextStyle),domProps:{"innerHTML":_vm._s(_vm.model.attributes.labelText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }